<template>

    <v-page-section padded>
        <template #body>
            <v-stats :stats="stats" />
        </template>
    </v-page-section>

</template>

<script>

import numeral from 'numeral';

export default {

    props: {
        counts: {
            type: Object,
            required: true,
        },
    },

    computed: {

        stats() {
            return [
                {
                    label: 'Sent',
                    value: numeral(this.counts.sent).format('0,00'),
                },
                {
                    label: 'Delivered',
                    value: this.formatValue(this.counts.delivered),
                    type: 'success',
                },
                {
                    label: 'Opened',
                    value: this.formatValue(this.counts.opened),
                },
                {
                    label: 'Clicked',
                    value: this.formatValue(this.counts.clicked),
                },
                {
                    label: 'Failed',
                    value: this.formatValue(this.counts.failed),
                    type: 'danger',
                },
            ];
        },

    },

    methods: {

        formatValue(val) {
            let perc = numeral(val / this.counts.sent).format('0.[0]%');
            return numeral(val).format('0,00') + ` / ${perc}`;
        },

    },

}

</script>